module.exports = __webpack_public_path__ + "img/IT0000103421451.65b43191.png";